import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
/**
 * This is used to provide a success or error summary message for forms
 * @export
 * @example
 * ```
 * FormFeedback validInput>Form feedback ( valid )</FormFeedback>
 * ```
 *
 * @example
 * ```
 * <FormFeedback validInput={false}>Form feedback ( invalid )</FormFeedback>
 * ```
 *
 * @category Feedback
 */
const FormFeedback = (props) => {
    // props
    const { validInput, className, children } = props;
    return (_jsx("div", { className: classNames("uxpcore_form-feedback", className, {
            "uxpcore_form-feedback--valid": validInput,
            "uxpcore_form-feedback--invalid": validInput === false
        }), children: children }));
};
export default FormFeedback;
